import type { OwnedAccount, SiteAccount } from '@hotjar/account';
import type { Site, SiteDTO } from '@hotjar/site';

import { BUSINESS, SCALE } from './feature-group';

export function isOnBusiness(site: SiteDTO | null): boolean {
  if (site) {
    return site.effective_plan === BUSINESS;
  }

  return false;
}

export function isScaleSelfServe(account: OwnedAccount | SiteAccount | undefined): boolean {
  if (!account) {
    return false;
  }

  return parseInt(account.pricingTableId, 10) < 7;
}

export function hasUnlimitedSessions(site?: Site): boolean {
  if (!site) {
    return false;
  }

  return !isScaleSelfServe(site.account) && site.effectivePlan === SCALE;
}
